(() => {
  const bar=document.getElementById('GenkiStickySearch');
  if(!bar)return;
  const search=bar.querySelector('predictive-search'), input=bar.querySelector('input[type=search]');
  const results=bar.querySelector('[data-predictive-search]'), footer=bar.querySelector('.genki-sticky-search__footer');
  const link=bar.querySelector('.genki-sticky-search__all');
  customElements.whenDefined('predictive-search').then(()=>{
    // The shop publishes a small first segment for fast homepage rendering.
    // Header search needs both complete stock segments, not just that preview.
    search.getIndexProducts=function(){
      if(this.indexPromise)return this.indexPromise;
      const load=async url=>{
        const response=await fetch(url,{signal:AbortSignal.timeout(30000)});
        if(!response.ok)throw new Error('Suchkatalog nicht erreichbar');
        const data=await response.json();
        if(data.chunked){
          if(!Array.isArray(data.chunks)||!data.chunks.length)throw new Error('Suchkatalog unvollständig');
          const chunks=[];
          for(const name of data.chunks){
            const r=await fetch(new URL(name,url),{signal:AbortSignal.timeout(30000)});
            if(!r.ok)throw new Error('Suchkatalog-Teil nicht erreichbar');
            const chunk=await r.json();
            if(chunk.generated_at!==data.generated_at||!Array.isArray(chunk.products))throw new Error('Suchkatalog wird aktualisiert');
            chunks.push(...chunk.products);
          }
          data.products=chunks;
        }
        if(!Array.isArray(data.products)||data.products.length!==data.product_count)throw new Error('Suchkatalog unvollständig');
        return data;
      };
      const url=new URL(this.dataset.indexUrl,location.href).toString();
      this.indexPromise=load(url).then(async first=>{
        let segments=[first];
        if(first.segment==='first'&&/-first\.json(?:\?|$)/.test(url)){
          segments=await Promise.all(['ready','soldout'].map(async segment=>{
            const data=await load(url.replace(/-first\.json(?=\?|$)/,`-${segment}.json`));
            if(data.segment!==segment||(data.collection_handle||'')!==(first.collection_handle||''))throw new Error('Falscher Suchkatalog');
            return data;
          }));
        }
        segments.sort((a,b)=>String(a.generated_at).localeCompare(String(b.generated_at)));
        const products=new Map();
        for(const segment of segments)for(const product of segment.products)if(product.handle&&product.handle!=='extra-versand')products.set(String(product.id||product.handle),product);
        return Array.from(products.values());
      }).catch(error=>{this.indexPromise=null;throw error;});
      return this.indexPromise;
    };
  });
  let frame=0;
  function layout(){
    frame=0;
    const spacer=document.getElementById('GenkiStickySearchSpace');
    if(spacer)spacer.style.height=`${bar.offsetHeight}px`;
    document.documentElement.style.setProperty('--genki-search-height',`${bar.offsetHeight}px`);
    const header=document.querySelector('.section-header');
    const headerPosition=header?getComputedStyle(header).position:'';
    document.documentElement.style.setProperty('--genki-header-search-offset',
      ['sticky','fixed'].includes(headerPosition)?`${bar.offsetHeight}px`:'0px');
    bar.style.setProperty('--genki-search-top','0px');
    const rect=bar.querySelector('.genki-sticky-search__inner').getBoundingClientRect();
    const viewport=window.visualViewport;
    const height=viewport?viewport.height+viewport.offsetTop:innerHeight;
    bar.style.setProperty('--genki-results-left',`${rect.left}px`);
    bar.style.setProperty('--genki-results-width',`${rect.width}px`);
    bar.style.setProperty('--genki-results-top',`${rect.bottom+8}px`);
    bar.style.setProperty('--genki-results-height',`${Math.max(80,Math.min(650,height-rect.bottom-72))}px`);
    footer.hidden=!search.hasAttribute('open');
    if(!footer.hidden)bar.style.setProperty('--genki-footer-top',`${results.getBoundingClientRect().bottom}px`);
    const url=new URL(link.getAttribute('href'),location.origin);url.searchParams.set('q',input.value.trim());url.searchParams.set('type','product');link.href=url.toString();
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(layout);}
  new MutationObserver(schedule).observe(search,{attributes:true,attributeFilter:['open','loading'],childList:true,subtree:true});
  new ResizeObserver(schedule).observe(results);
  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
  window.visualViewport?.addEventListener('resize',schedule,{passive:true});
  bar.querySelector('.genki-sticky-search__close').addEventListener('click',()=>{input.focus();search.close?.();});
  bar.addEventListener('keydown',event=>{if(event.key==='Escape'){search.close?.();event.preventDefault();}});
  document.addEventListener('pointerdown',event=>{if(!bar.contains(event.target))search.close?.();});
  input.addEventListener('input',schedule);
  layout();
})();
